import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Reusable UI primitives
export function Kicker({ children, dark = false, className = "" }) {
  return (
    <span className={`font-sans text-[11px] tracking-luxe uppercase ${dark ? "text-gold-soft" : "text-gold"} ${className}`}>
      {children}
    </span>
  );
}

export function ButtonLink({ to, children, variant = "navy", className = "" }) {
  const styles = {
    navy: "bg-navy text-cream hover:bg-gold hover:text-navy",
    gold: "bg-gold text-navy hover:bg-navy hover:text-cream",
    outline: "border border-navy text-navy hover:bg-navy hover:text-cream",
    outlineLight: "border border-cream/40 text-cream hover:bg-cream hover:text-navy"
  };
  return (
    <Link
      to={to}
      className={`group inline-flex items-center gap-3 px-8 py-4 font-sans text-[12px] tracking-wide-nav uppercase transition-all duration-400 ${styles[variant]} ${className}`}
    >
      {children}
      <ArrowRight size={16} strokeWidth={1.5} className="transition-transform duration-300 group-hover:translate-x-1" />
    </Link>
  );
}

export function SectionHeading({ kicker, title, dark = false, center = false, className = "" }) {
  return (
    <div className={`${center ? "text-center mx-auto" : ""} ${className}`}>
      {kicker && <Kicker dark={dark}>{kicker}</Kicker>}
      <h2 className={`font-serif font-medium leading-[1.08] mt-4 text-4xl md:text-5xl lg:text-[3.4rem] ${dark ? "text-cream" : "text-navy"}`}>
        {title}
      </h2>
    </div>
  );
}
